module.exports = __webpack_public_path__ + "img/introduce-6.7736c11f.png";